// extracted by mini-css-extract-plugin
export default {"root":"MostConnectedExecutives_root__YiP1T","header":"MostConnectedExecutives_header__u4E7Q","container":"MostConnectedExecutives_container__gHDM7"};